import { defineStore } from 'pinia'
import { ref } from 'vue'

// Admin-only "edit content in place" toggle. Client-only — the real authority is the ADMIN-gated
// by-name PUT, so flipping this never hits the server; it just reveals the ✎ affordances on every
// <ContentText> region. Persisted to sessionStorage so it survives navigation/reload within a session.
const STORAGE_KEY = 'contentEditMode'

export const useEditModeStore = defineStore('editMode', () => {
  const on = ref(readInitial())

  function readInitial(): boolean {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === '1'
    } catch {
      return false
    }
  }
  function set(value: boolean) {
    on.value = value
    try {
      sessionStorage.setItem(STORAGE_KEY, value ? '1' : '0')
    } catch {
      /* ignore storage failures */
    }
  }
  function toggle() {
    set(!on.value)
  }

  return { on, set, toggle }
})
